<template>
    <div class="kb-block-link">
        <router-link :to="to">
            <div
                class="info-wrapper"
                v-if="title || details">
                <h3 v-if="title">{{ title }}</h3>
                <p v-if="details">{{ details }}</p>
            </div>
            <slot></slot>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'kb-block-link',

        props: ['to', 'title', 'details'],

        data() {
            return {};
        },
    }
</script>

<style lang="scss" scoped>
    .kb-block-link {
        font-size: 16px;
        background-color: #363636;
        color: #f0f0f0;
        box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);

        a {
            display: block;
            width: 100%;
            height: 100%;
            position: relative;
            color: inherit;
            text-decoration: none;

            &:hover::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 3px;
                bottom: 0;
                background-color: #33ccff;
                z-index: 1;
            }
        }

        .info-wrapper {
            padding: 15px 20px;
            h3 {
                margin: 10px 0;
                color: #33ccff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// KbBlockLink.vue?e027c8e6